import { urlBlockedError, genericError } from '@/global/constants/toastErrors'
import { toast } from 'react-toastify'

interface ToastApiErrorProps {
  status?: number
}

const toastApiError = ({ status }: ToastApiErrorProps = {}) => {
  const error = status === 403 ? urlBlockedError : genericError
  toastError(error.toastId, error.message)
}

const toastError = (toastId: string, message: string) => {
  if (!toast.isActive(toastId)) {
    toast(message, { toastId })
  }
}

export { toastApiError }
